import { Space } from 'antd'
import Uploadfiles from '../../../../modules/uploadfiles'
import { FINANCIAL_INVOICE_FILE_TYPE } from '../../../financialreconciliationdetail'
import { fileFile } from '../../../../modules/uploadfiles/hooks'

interface Props {
  value?: fileFile[]
  onChange?: (e: fileFile[]) => void
  handleRecognize?: (file?: fileFile[]) => void
  disabled?: boolean
  hiddenDownload?: boolean
}

const UploadSingleInvoice = (props: Props) => {
  const { value, onChange, disabled, hiddenDownload } = props

  return (
    <Space align="start">
      <Uploadfiles
        title="选择文件"
        type="invoice"
        accept={FINANCIAL_INVOICE_FILE_TYPE}
        maxCount={1}
        directlyDelete
        dataSource={value}
        onChange={onChange}
        disabled={disabled}
        hiddenDownload={hiddenDownload}
      />
    </Space>
  )
}

export default UploadSingleInvoice
import { Space } from 'antd'
import Uploadfiles from '../../../../modules/uploadfiles'
import { FINANCIAL_INVOICE_FILE_TYPE } from '../../../financialreconciliationdetail'
import { fileFile } from '../../../../modules/uploadfiles/hooks'

interface Props {
  value?: fileFile[]
  onChange?: (e: fileFile[]) => void
  handleRecognize?: (file?: fileFile[]) => void
  disabled?: boolean
  hiddenDownload?: boolean
}

const UploadSingleInvoice = (props: Props) => {
  const { value, onChange, disabled, hiddenDownload } = props

  return (
    <Space align="start">
      <Uploadfiles
        title="选择文件"
        type="invoice"
        accept={FINANCIAL_INVOICE_FILE_TYPE}
        maxCount={1}
        directlyDelete
        dataSource={value}
        onChange={onChange}
        disabled={disabled}
        hiddenDownload={hiddenDownload}
      />
    </Space>
  )
}

export default UploadSingleInvoice
